import {withOrganizationCodeFeedback} from "../../js/withOrganizationCodeFeedback";
import createBaseForm from "../../components/custom-form-theme/CreateBaseForm";

// NB : actuellement les paramètres sont déduits de variable dataset
export default function registerCustomerForm(formName = null, storeName = null,
                                             sfFieldNameSuffix = null, params = {} ) {

    const form = withOrganizationCodeFeedback(
        createBaseForm(formName, storeName, sfFieldNameSuffix, params)
    );

    form.passwordsMatch= function() {
        console.log('passwordsMatch' +  this.form.plainPassword  + ' - ' + this.form.plainPasswordConfirm );
        return this.store.passwordsMatch()
    };

    return form;
}
